// src/features/dashboard/layout/DashboardLayout.jsx
import React, { useState } from 'react';
import { Box, Toolbar, useTheme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { useSocketManager } from '../../store/useSocketManager';

const DRAWER_WIDTH = 280;

export function DashboardLayout() {
    const theme = useTheme();
    useSocketManager();

    // true = mobile (< sm = 600px)
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                bgcolor: 'background.default',
            }}
        >
            {/* ── Navbar fixe en haut ── */}
            <Navbar
                onMenuClick={() => setMobileOpen((prev) => !prev)}
                drawerWidth={DRAWER_WIDTH}
            />

            {/* ── Sidebar ── */}
            {/*
                On définit une largeur fixe sur desktop pour réserver l'espace
                du Drawer permanent, sinon le contenu principal passe en dessous.
            */}
            <Box component="nav" sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}>
                <Sidebar
                    open={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    isMobile={isMobile}
                    drawerWidth={DRAWER_WIDTH}
                />
            </Box>

            {/* ── Zone de contenu principale ── */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    p: { xs: 2, sm: 4 },
                }}
            >
                {/*
                    Toolbar vide = espace réservé sous la Navbar fixe.
                    Sa hauteur correspond automatiquement à celle de l'AppBar MUI.
                */}
                <Toolbar sx={{ mb: 2 }} />

                {/* Contenu de la route active */}
                <Box sx={{ flexGrow: 1 }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}